// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"195":"fd947e42","495":"4e16f572","590":"31d6cfe0"}[chunkId] + ".chunk.css";
};